//? DTO

import { z } from "zod";

export const CreateFulfillmentDtoSchema = z.object({
  ServiceProviderId: z.number().nullish(),
  Value: z.number().nullish(),
  DueDate: z.string().nullish(),
  State: z.number().nullish(),
  AgencyCharge: z.number().nullish(),
  Expenses: z.number().nullish(),
  InvoiceNumber: z.string().nullish(),
});
export type CreateFulfillmentDto = z.infer<typeof CreateFulfillmentDtoSchema>;

export const FulfillmentDtoSchema = CreateFulfillmentDtoSchema.extend({
  Id: z.number(),
});
export type FulfillmentDto = z.infer<typeof FulfillmentDtoSchema>;

//? Model

export enum FulfillmentState {
  NotPayed = "NotPayed",
  Payed = "Payed",
}

export const fulfillmentStateEnumToNumber: Record<FulfillmentState, number> = {
  NotPayed: 0,
  Payed: 1,
};

const fulfillmentStateNumToEnum = Object.entries(
  fulfillmentStateEnumToNumber,
).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {}) as Record<
  number,
  FulfillmentState
>;

export const FulfillmentsStateAsArray = Object.values(FulfillmentState);

export const CreateFulfillmentSchema = z.object({
  serviceProviderId: z.number().nullish(),
  value: z.number().nullish(),
  dueDate: z.date().nullish(),
  state: z.nativeEnum(FulfillmentState).nullish(),
  agencyCharge: z.number().nullish(),
  expenses: z.number().nullish(),
  invoiceNumber: z.string().nullish(),
});

export type CreateFulfillment = z.infer<typeof CreateFulfillmentSchema>;

export const FulfillmentSchema = CreateFulfillmentSchema.extend({
  id: z.string(),
});

export type Fulfillment = z.infer<typeof FulfillmentSchema>;
export type HotelFulfillment = Fulfillment & {
  hotelRoomId: number | null | undefined;
  hotelId: number | null | undefined;
};
export type ServiceFulfillment = Fulfillment & {
  serviceId: number | null | undefined;
};
//? Mappers

export function fulfillmentFromDto(dto: FulfillmentDto): Fulfillment {
  return {
    id: dto.Id.toString(),
    value: dto.Value,
    serviceProviderId: dto.ServiceProviderId,
    state:
      typeof dto.State === "number"
        ? fulfillmentStateNumToEnum[dto.State]
        : undefined,
    dueDate: dto.DueDate ? new Date(dto.DueDate) : undefined,
    agencyCharge: dto.AgencyCharge,
    expenses: dto.Expenses,
    invoiceNumber: dto.InvoiceNumber,
  };
}

export function fulfillmentToDto(model: Fulfillment): FulfillmentDto {
  return {
    Id: Number.parseInt(model.id),
    ...createFulfillmentToDto(model),
  };
}

export function createFulfillmentToDto(
  model: CreateFulfillment,
): CreateFulfillmentDto {
  return {
    Value: model.value,
    State: model.state ? fulfillmentStateEnumToNumber[model.state] : undefined,
    AgencyCharge: model.agencyCharge,
    DueDate: model.dueDate?.toDateString(),
    Expenses: model.expenses,
    InvoiceNumber: model.invoiceNumber,
    ServiceProviderId: model.serviceProviderId,
  };
}
